import { createContext } from 'lib/createContext'

export type CallState = 'idle' | 'connecting' | 'active' | 'ended' | 'error'

export type TranscriptEntry = {
  role: 'user' | 'assistant'
  text: string
  isFinal: boolean
  timestamp: number
}

export type VoiceAgentCallContextState = {
  state: {
    title: string
    callState: CallState
    callId: string | null
    error: string | null
    isMuted: boolean
    transcript: TranscriptEntry[]
  }
  actions: {
    startCall: () => void
    endCall: () => void
    reset: () => void
    toggleMute: () => void
  }
}

export const [VoiceAgentCallContext, useVoiceAgentCallContextValue] =
  createContext<VoiceAgentCallContextState>({
    name: 'VoiceAgentCallContext',
  })
